import { render, staticRenderFns } from "./albaranes_pendientes.vue?vue&type=template&id=48011049&"
import script from "./albaranes_pendientes.vue?vue&type=script&lang=js&"
export * from "./albaranes_pendientes.vue?vue&type=script&lang=js&"
import style0 from "./albaranes_pendientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports